import React, { useState } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import apiUrl from "../Apiurl";

export function CreazioneKitContent({
  onClose,
  token,
  onSuccess,
  embedded = false,
  showClose = false,
}) {
  const [codVS_nuovo, setCodVS_nuovo] = useState("");
  const [codVS_predominante, setCodVS_predominante] = useState("");
  const [codVS_secondari, setCodVS_secondari] = useState([""]);
  const [id_ps, setId_ps] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const aggiungiCodiceSecondario = () => {
    setCodVS_secondari([...codVS_secondari, ""]);
  };

  const rimuoviCodiceSecondario = (index) => {
    if (codVS_secondari.length > 1) {
      setCodVS_secondari(codVS_secondari.filter((_, i) => i !== index));
    }
  };

  const aggiornaCodiceSecondario = (index, value) => {
    const nuoviCodici = [...codVS_secondari];
    nuoviCodici[index] = value;
    setCodVS_secondari(nuoviCodici);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);

    // Validazione client-side
    if (!codVS_nuovo.trim()) {
      setError("Il codVS nuovo è obbligatorio");
      setLoading(false);
      return;
    }
    if (!codVS_predominante.trim()) {
      setError("Il codVS predominante è obbligatorio");
      setLoading(false);
      return;
    }
    const codiciSecondariPuliti = codVS_secondari
      .map((c) => c.trim())
      .filter((c) => c);
    if (codiciSecondariPuliti.length === 0) {
      setError("Almeno un codVS secondario è obbligatorio");
      setLoading(false);
      return;
    }
    if (!id_ps || isNaN(Number(id_ps))) {
      setError("L'ID PrestaShop deve essere un numero valido");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${apiUrl}/prodotti/createKit`,
        {
          codVS_nuovo: codVS_nuovo.trim(),
          codVS_predominante: codVS_predominante.trim(),
          codVS_secondari: codiciSecondariPuliti,
          id_ps: Number(id_ps),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccess(
        response.data.message ||
          `Kit "${codVS_nuovo}" creato con successo!`
      );
      
      // Reset form dopo successo
      setTimeout(() => {
        if (onSuccess) {
          onSuccess(response.data);
        }
      }, 1500);
    } catch (err) {
      console.error("Errore durante la creazione del kit:", err);
      setError(
        err.response?.data?.error ||
          err.response?.data?.details ||
          "Errore durante la creazione del kit"
      );
    } finally {
      setLoading(false);
    }
  };

  const containerClass = embedded
    ? "pa3 br3 ba b--black-10 bg-white"
    : "bg-white pa4 br3 shadow-1 mw6 w-100 ma3 relative";
  const containerStyle = embedded
    ? {}
    : { maxHeight: "90vh", overflowY: "auto" };

  return (
    <div className={containerClass} style={containerStyle}>
      <div className="flex justify-between items-center mb3 bb pb2">
        <h2 className="ma0 f4 b">Crea Articolo Kit</h2>
        {showClose && (
          <button
            onClick={() => onClose?.()}
            className="pointer bn bg-transparent pa0 absolute top-1 right-1"
            style={{ fontSize: "24px" }}
            aria-label="Chiudi modale creazione kit"
          >
            ×
          </button>
        )}
      </div>

      <form onSubmit={handleSubmit}>
        {/* codVS Nuovo */}
        <div className="mb3">
          <label className="db fw6 mb2">
            codVS Nuovo (per il kit) <span className="red">*</span>
          </label>
          <input
            type="text"
            value={codVS_nuovo}
            onChange={(e) => setCodVS_nuovo(e.target.value)}
            className="w-100 pa2 ba br2"
            placeholder="Es: KIT001"
            required
          />
        </div>

        {/* codVS Predominante */}
        <div className="mb3">
          <label className="db fw6 mb2">
            codVS Predominante <span className="red">*</span>
          </label>
          <input
            type="text"
            value={codVS_predominante}
            onChange={(e) => setCodVS_predominante(e.target.value)}
            className="w-100 pa2 ba br2"
            placeholder="Es: ABC123"
            required
          />
          <small className="db mt1 gray">
            I dati di questo articolo verranno usati come base
          </small>
        </div>

        {/* codVS Secondari */}
        <div className="mb3">
          <label className="db fw6 mb2">
            codVS Secondari <span className="red">*</span>
          </label>
          {codVS_secondari.map((codice, index) => (
            <div key={index} className="flex items-center mb2">
              <input
                type="text"
                value={codice}
                onChange={(e) =>
                  aggiornaCodiceSecondario(index, e.target.value)
                }
                className="flex-1 pa2 ba br2"
                placeholder={`codVS secondario #${index + 1}`}
              />
              {codVS_secondari.length > 1 && (
                <button
                  type="button"
                  onClick={() => rimuoviCodiceSecondario(index)}
                  className="ml2 pa2 bn bg-light-red red pointer br2"
                  title="Rimuovi"
                >
                  <span className="material-icons" style={{ fontSize: "18px" }}>
                    delete
                  </span>
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            onClick={aggiungiCodiceSecondario}
            className="pa2 bn bg-light-green green pointer br2 flex items-center"
          >
            <span className="material-icons mr1" style={{ fontSize: "18px" }}>
              add
            </span>
            Aggiungi codVS secondario
          </button>
        </div>

        {/* ID PrestaShop */}
        <div className="mb3">
          <label className="db fw6 mb2">
            ID PrestaShop <span className="red">*</span>
          </label>
          <input
            type="number"
            value={id_ps}
            onChange={(e) => setId_ps(e.target.value)}
            className="w-100 pa2 ba br2"
            placeholder="Es: 12345"
            required
          />
        </div>

        {/* Messaggi di errore/successo */}
        {error && (
          <div className="pa3 mb3 bg-washed-red red br2">{error}</div>
        )}
        {success && (
          <div className="pa3 mb3 bg-washed-green green br2">{success}</div>
        )}

        {/* Pulsanti */}
        <div className="flex justify-end gap2">
          <button
            type="button"
            onClick={() => onClose?.()}
            className="pa2 ph3 bn bg-light-gray dark-gray pointer br2"
            disabled={loading}
          >
            Annulla
          </button>
          <button
            type="submit"
            className="pa2 ph3 bn bg-blue white pointer br2"
            disabled={loading}
          >
            {loading ? "Creazione in corso..." : "Crea Kit"}
          </button>
        </div>
      </form>
    </div>
  );
}

function CreazioneKit({ onClose, token, onSuccess }) {
  return createPortal(
    <div
      className="fixed top-0 left-0 w-100 h-100 flex items-center justify-center z-999"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <CreazioneKitContent
        onClose={onClose}
        token={token}
        onSuccess={onSuccess}
        showClose
      />
    </div>,
    document.body
  );
}

export default CreazioneKit;
